export type ChartDataSet = {
  name: string
  values: Array<number>
  chartType?: string
}

export type XYRecord = {
  x: number
  label: string
  values: Array<number | null>
}

export const buildXYRecords = (
  labels: Array<string>,
  datasets: Array<ChartDataSet>
): Array<XYRecord> => {
  if (!labels.length) {
    return []
  }
  const maxLength = labels.length

  return Array.from({ length: maxLength }).map((_, index) => {
    const label = labels[index] ?? `${index + 1}`
    const values = datasets.map((dataset) =>
      typeof dataset.values[index] === 'number' ? dataset.values[index] : null
    )

    return {
      x: index,
      label,
      values
    }
  })
}
